import { rolesData } from "@legal-500/permissions";
import { PageHeader } from "../../../components/PageHeader";
import styles from "../UserManagement.module.css";

type RoleEntry = {
  name: string;
  context: string;
  description: string;
  permissions: string[];
};

const rolesByContext = (rolesData as RoleEntry[]).reduce<Record<string, RoleEntry[]>>(
  (grouped, role) => {
    const group = grouped[role.context] ?? [];
    return { ...grouped, [role.context]: [...group, role] };
  },
  {},
);

const contextOrder = ["staff", "account-services", "service"];

function sortedContexts(contexts: string[]): string[] {
  return [...contexts].sort((contextA, contextB) => {
    const indexA = contextOrder.indexOf(contextA);
    const indexB = contextOrder.indexOf(contextB);
    if (indexA !== -1 && indexB !== -1) return indexA - indexB;
    if (indexA !== -1) return -1;
    if (indexB !== -1) return 1;
    return contextA.localeCompare(contextB);
  });
}

function RolesPage() {
  const contexts = sortedContexts(Object.keys(rolesByContext));

  return (
    <div className={styles.wrapper}>
      <div>
        <PageHeader
          title="Roles & Permissions"
          subtitle="All platform roles and their associated permissions"
        />
      </div>

      <div className={styles.detailWrapper} style={{ paddingLeft: 0, paddingRight: 0 }}>
        {contexts.map(context => (
          <div key={context} className={styles.section}>
            <div className={styles.sectionHeader}>
              <h2 className={styles.sectionTitle} style={{ margin: 0 }}>
                {context}
              </h2>
              <span className={styles.contextBadge}>{context}</span>
            </div>
            <table className={styles.rolesTable}>
              <thead>
                <tr>
                  <th>Role</th>
                  <th>Description</th>
                  <th>Permissions</th>
                </tr>
              </thead>
              <tbody>
                {rolesByContext[context]?.map(role => (
                  <tr key={role.name}>
                    <td>
                      <code style={{ fontSize: "var(--font-size-sm)" }}>{role.name}</code>
                    </td>
                    <td>{role.description}</td>
                    <td>
                      <div className={styles.permissionList}>
                        {role.permissions.map(permission => (
                          <span key={permission} className={styles.permissionTag}>
                            {permission}
                          </span>
                        ))}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </div>
    </div>
  );
}

export default RolesPage;
